import { useState } from "react";

const useSpeech = (onFinish) => {
  const [isSpeaking, setIsSpeaking] = useState(false);

  const speak = (text) => {
    if (!text || isSpeaking) return;
    
    const speech = new SpeechSynthesisUtterance(text);

    // Set the language to Brazilian Portuguese (pt-BR)
    speech.lang = "pt-BR";

    // Handle the speech start and end events
    speech.onstart = () => setIsSpeaking(true);

    speech.onend = () => {
      setIsSpeaking(false);
      if (onFinish) onFinish(text); // Trigger the onFinish callback when speech ends
    };

    // Speak the text
    window.speechSynthesis.speak(speech);
  };

  const stop = () => {
    window.speechSynthesis.cancel();
    setIsSpeaking(false);
  };

  return {
    speak,
    stop,
    isSpeaking
  };
};

export default useSpeech;
